/**
 * 接口请求加解密常量配置
 *
 * 从 encrypt.ts 中剥离出的纯常量，不依赖任何加密库，
 * 可以被同步 import 而不会引入 crypto-js/jsencrypt 等大库到主包
 */

// ====== 全局密钥常量（与 vue2 项目保持一致） ======
export const RSA_PUBLIC_KEY
  = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAgcL7TNHwjZ05dif0bcdaxi/PfIwq5UWl8GC3nU37aMqD+B6FedsjjBFVMvZrN/ATbl9/ofxAfyin58IcKSrIHdi7yqPiXainTB1bwbrkweWXE2zchYDMyS3bia7uUXFajpw8Dj9URPnYr63//jOJqoRPRrqqtNgJiqUeHYZB5ADZA6H++VzwULEUc8SCBroLrIvpgWQB0Ji3LLvwW5uBo87JXZGiZEvyTC11QRYjxUCgjDNskoUrfVmIMUQgelG96+yvMd6Co0/ohjQM/nO43Fp08xygNcB/4x7+nZvmQYc8j8MF3Xvk2rApRlIIhrz7lamcoB8f2mnL2JiD1AQ3kQIDAQAB';

export const HMAC_SECRET = 'your-hmac-secret-key-keep-safe';

/** 响应解密用的固定 AES 密钥（与服务端约定） */
export const RESPONSE_AES_SECRET = 'LXYSY3lqVyoa+8qskOZaUxgQZbLjhWY1q819ljLcIY4=';
